import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { GungSettingsPunchoutOrderRequestsTableComponent } from '../components/gung-settings/gung-settings-punchout/punchout-order-requests/gung-settings-punchout-order-requests-table.component';
import {
  PunchoutAuditConfigFilter,
  PunchoutAuditMonthFilter,
  PunchoutAuditStatusFilter
} from '../filters/punchout-audit/punchout-audit.filters';
import { PunchoutAuditEventType, PunchoutAuditListItem } from '../models/punchout';
import { PunchoutAuditListConfigBase } from './punchout-audit-list-config.base';

/**
 * Order requests: purchase orders delivered by the procurement platform to the public cXML
 * endpoint. Receiving these does not need the EDI module, but processing them does. On an app
 * without EDI, they accumulate as RECEIVED and can only be viewed, not reprocessed.
 */
@Injectable({ providedIn: 'root' })
export class PunchoutAuditOrderRequestListConfigService extends PunchoutAuditListConfigBase {
  protected readonly eventType: PunchoutAuditEventType = 'ORDER_REQUEST';

  getFilters(route?: ActivatedRouteSnapshot): ConfigBaseFilter<PunchoutAuditListItem>[] {
    return [new PunchoutAuditConfigFilter(), new PunchoutAuditStatusFilter(), new PunchoutAuditMonthFilter()];
  }

  getLayouts(route?: ActivatedRouteSnapshot): ListLayout<PunchoutAuditListItem>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => GungSettingsPunchoutOrderRequestsTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'list'
      }
    ];
  }
}
